import { render, staticRenderFns } from "./zCampoValor.vue?vue&type=template&id=0fb42600&scoped=true&"
import script from "./zCampoValor.vue?vue&type=script&lang=js&"
export * from "./zCampoValor.vue?vue&type=script&lang=js&"
import style0 from "./zCampoValor.vue?vue&type=style&index=0&id=0fb42600&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fb42600",
  null
  
)

export default component.exports